import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import NewsItem from "./newsitem"


export const query = graphql`
  {
    allStrapiNewsPosts(sort: { order: DESC, fields: date }, limit: 2) {
      nodes {
        title
        thumb {
          childImageSharp {
            fluid(quality: 90) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        content
        date(formatString: "YYYY MM DD")
        excerpt
        slug
        id
      }
    }
    file(relativePath: { eq: "bg-news.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const NewsList = () => {
    const {
      allStrapiNewsPosts: { nodes: newsCollection }, file:fotka
    } = useStaticQuery(query)

    return (
      <BackgroundImage
        Tag="section"
        className={`news-pietro py-5`}
        fluid={fotka.childImageSharp.fluid}
        backgroundColor={`#000`}
        >
            <div className="bg-overlay"></div>
        <section className="news-pietro py-5">
          <div className="container py-5">
            <h2 className="text-center mb-5 font-bold section-title text-white">
              NEWS
            </h2>
            <div className="row">
                {newsCollection.map((news, i) => (
                  <NewsItem key={news.id} {...news} />
                ))}
            </div>
            <div className="row mt-5 justify-content-center">
              <Link to="/news-list"
                className="btn btn-rounded btn-secondary"
              >
                More news
                <span className="icon-arr-right ml-3 color-red"></span>
              </Link>
            </div>
          </div>
        </section>
      </BackgroundImage>
    )
}

export default NewsList
